import COSHHForm from "./form";

const CreateCOSHHPage = () => {
  return (
    <div className="w-full min-h-screen bg-[#F6F7F9]">
      <main className="mx-auto w-full max-w-[1200px] px-4 md:px-8">
        <div className="py-6">
          <div className="mb-8">
            <h1 className="text-2xl font-semibold text-neutral-900">
              Create COSHH Assessment
            </h1>
            <p className="mt-1 text-sm text-neutral-500">
              Assess risks associated with hazardous substances.
            </p>
          </div>

          <div className="w-full">
            <COSHHForm />
          </div>
        </div>
      </main>
    </div>
  );
};

export default CreateCOSHHPage;
